<template>
  <div>
    <div class="card">
      <div class="card-header" style="height: 3rem;" id="headingAlert">
        <h5>Visuals</h5>
      </div>
      <div class="card-body" v-if="feature_visual_alert_enabled">
        <div v-if="filtered_advanced_visuals.length === 0">
          <b>Click below to add a new visual.</b>
        </div>
        <div id="carouselVisuals" class="carousel slide" data-interval="false" v-if="filtered_advanced_visuals.length > 0">
          <div class="carousel-inner" ref="carousel">
            <div v-for="advanced_visual, index in filtered_advanced_visuals" :class="{ 'carousel-item': true, active: index === 0 }">
              <AdvancedVisualPreview :advanced_visual="advanced_visual" />
              <div class="d-flex">
                <div class="dropup">
                  <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" href="#" @click.prevent="() => previewVisual(advanced_visual)">
                          <i class="fa fa-image fa-fw" aria-hidden="true"></i>&nbsp;View
                      </a>
                      <router-link class="dropdown-item" :to="{ name: 'AdvancedVisualEdit', params: { event_id, advanced_visual_id: advanced_visual.advanced_visual_id } }">
                          <i class="fa fa-edit fa-fw" aria-hidden="true"></i>&nbsp;Edit
                      </router-link>
                      <a class="dropdown-item" href="#" @click.prevent="() => deleteVisual(advanced_visual)">
                          <i class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete
                      </a>
                  </div>
                </div>
                <span class="w-100 pl-3 pt-1 border" style="background: #eee">
                  {{ advanced_visual.name }}
                </span>
              </div>
            </div>
          </div>
          <div class="carousel-control-prev" data-target="#carouselVisuals" role="button" data-slide="prev" v-if="filtered_advanced_visuals.length > 1">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </div>
          <div class="carousel-control-next" data-target="#carouselVisuals" role="button" data-slide="next" v-if="filtered_advanced_visuals.length > 1">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only" style="color: black">Next</span>
          </div>
        </div>
        <div class="new-visual-btn" @click="addNewVisual">
          <i class="fa fa-plus" aria-hidden="true"></i><div>Add New Visual</div>
        </div>
      </div>
      <div class="card-body" v-else>
        <div class="row">
          <div class="col-12">
            <p class="d-inline mr-2"><strong>Visual Alerts is not enabled for your account.</strong></p>
            <ToggleContent toggleText="More info">
              <h3>G2 Visual Alerts</h3>
              <p>G2 Visual Alerts allows for instant visual communication anytime and anywhere. It enables administrators to deploy timely notifications to any enabled device within the ecosystem, both on- and off-campus.</p>
              <h4>How does it work?</h4>
              <p>With just a few clicks from an internet-ready or mobile device, administrators can initiate text, image, and video messages to any enrolled device within seconds. The G2 Communicator application makes it easy to manage and customize G2 Visual Alerts, and alerts can be triggered from any device or mobile phone. </p>
              <h4>Features</h4>
              <ul>
                <li>Compatible with Android, Linux, Mac OS, Windows, and Chrome</li>
                <li>Runs in the background</li>
                <li>Customizable text, images, colors, and more</li>
                <li>Ability to deploy messages to a single device or to a group</li>
              </ul>
              <p>Upgrade your communication and security capabilities with G2 Visual Alerts.</p>
              <p><strong>For more information, please visit our website at <a href="https://www.galaxynext.us/">https://www.galaxynext.us/</a>, or contact us at <a href="mailto:sales@galaxynext.us">sales@galaxynext.us</a> to get started.</strong></p>
            </ToggleContent>
          </div>
        </div>
      </div>
    </div>
    <Modal modal_id='previewVisualModal'>
      <template v-if="advanced_visual_to_preview !== null" v-slot:title>
        Preview {{ advanced_visual_to_preview.name }}
      </template>
      <template  v-if="advanced_visual_to_preview !== null" v-slot:body>
        <AdvancedVisualPreview :event_id="event_id" :advanced_visual="advanced_visual_to_preview" />
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '../../router'
import AdvancedVisualPreview from '../Visual/AdvancedVisualPreview'
import Modal from '../Modal'
import ToggleContent from '../ToggleContent'

export default {
  props: {
    event_id: [Number, String],
  },
  components: { AdvancedVisualPreview, Modal, ToggleContent },
  data: function () {
    return {
      advanced_visual_to_preview: null
    }
  },
  computed: {
    ...mapGetters({
      advanced_visuals: 'allAdvancedVisuals',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled'
    }),
    filtered_advanced_visuals() {
      return this.advanced_visuals.filter((v) => v.event_id === parseInt(this.event_id))
    }
  },
  created () {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX')
    this.$store.dispatch('getAdvancedVisuals')
  },
  methods: {
    ...mapActions(['deleteAdvancedVisual']),
    previewVisual(advancedVisual) {
      this.advanced_visual_to_preview = advancedVisual
      $('#previewVisualModal').modal('show')
    },
    deleteVisual(advancedVisual) {
      this.deleteAdvancedVisual(advancedVisual)
        .then(() => {
          const firstVisual = this.$refs.carousel.childNodes[0]
          if(firstVisual) {
            firstVisual.classList.add('active')
          }
        })
    },
    addNewVisual() {
      router.push({ name: 'AdvancedVisualAdd', params: { event_id: this.event_id } })
    }
  }
}
</script>

<style scoped>
.carousel-inner {
  width: 50%;
  margin: auto;
}
.carousel-control-prev {
  background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
}
.carousel-control-next {
  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
}

.new-visual-btn {
  background-color: rgb(245, 245, 245);
  border: 1px solid #ccc;
  padding: 0.25rem;
  margin-top: 0.5rem;
  text-align: center;
}

.new-visual-btn > i {
  font-size: 1.5rem;
}

.new-visual-btn > div {
  display: inline-block;
  height: 0;
  width: 0;
  overflow: hidden;
  transition-property: width;
  transition-duration: 250ms;
  transition-delay: 100ms;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.new-visual-btn:hover {
  background-color: rgb(198, 197, 197);
  cursor: pointer;
}

.new-visual-btn:hover > div {
  height: 1.25rem;
  width: 130px;
}

</style>
